import { accTypeOf, accessoriesFor, formatPrice } from "@/lib/store";

export const COMBO_OFF = 0.1;
export const COMBO_PAIRS = [
  { id: "carga", a: "fonte", b: "cabo", label: "Fonte + Cabo" },
  { id: "protecao", a: "pelicula", b: "capa", label: "Película + Capa" },
];
const SUGGEST_TYPES = ["pelicula", "capa", "fonte", "cabo"];
const cents = (v) => Math.round(v * 100) / 100;

export const suggestionsFor = (all, model) =>
  accessoriesFor(all, model, 40).filter((a) => SUGGEST_TYPES.includes(accTypeOf(a))).slice(0, 8);

const cheapest = (list, type) => list.filter((a) => accTypeOf(a) === type && a.price > 0).sort((x, y) => x.price - y.price)[0];

export const combosFor = (list) => COMBO_PAIRS.map((c) => {
  const a = cheapest(list, c.a);
  const b = cheapest(list, c.b);
  if (!a || !b) return null;
  const full = a.price + b.price;
  return { ...c, items: [a, b], full, price: cents(full * (1 - COMBO_OFF)) };
}).filter(Boolean);

// entries: [{ product, qty }] -> desconto de 10% nos pares fonte+cabo e película+capa
export const comboDiscount = (entries) => {
  const units = (type) => entries
    .filter((e) => accTypeOf(e.product) === type && e.product.price > 0)
    .flatMap((e) => Array(e.qty || 1).fill(e.product.price))
    .sort((x, y) => y - x);
  const lines = COMBO_PAIRS.map((c) => {
    const a = units(c.a);
    const b = units(c.b);
    const n = Math.min(a.length, b.length);
    const amount = cents([...a.slice(0, n), ...b.slice(0, n)].reduce((s, v) => s + v, 0) * COMBO_OFF);
    return n ? { label: `Combo ${c.label}${n > 1 ? ` (${n}x)` : ""} -10%`, amount } : null;
  }).filter(Boolean);
  return { lines, total: cents(lines.reduce((s, l) => s + l.amount, 0)) };
};

export const discountText = (d) => d.lines.map((l) => `${l.label}: -${formatPrice(l.amount)}`);
